import React from 'react';
import createSvgIcon from '../../../general/icons/createSvgIcon';

const Icon = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M3 3H7.5L9 4.5H15C15.825 4.5 16.5 5.175 16.5 6V13.5C16.5 14.325 15.825 15 15 15H3C2.175 15 1.5 14.325 1.5 13.5L1.5075 4.5C1.5075 3.675 2.175 3 3 3ZM8.3775 6L6.8775 4.5H3V13.5H15V6H8.3775Z"
  />,
  'Folder',
);

export const Folder = (props: any) => <Icon viewBox="0 0 18 18" {...props} />;
